import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";
import { BRAND_MONTH_OPTIONS, getBrandYearOptions } from "../../../../../Brands/brandsMonthYearOptions";

interface BrandsMonthYearFilterProps {
  selectedMonth: number;
  onSelectedMonthChange: (month: number) => void;
  selectedYear: number;
  onSelectedYearChange: (year: number) => void;
  disabled?: boolean;
}

// Mobile's Month/Year filter pair, next to BrandsSelector.tsx's Brand
// dropdown - same plain MUI Select pattern (a native menu, no on-screen
// keyboard) since both are short fixed lists.
export default function BrandsMonthYearFilter({
  selectedMonth,
  onSelectedMonthChange,
  selectedYear,
  onSelectedYearChange,
  disabled = false,
}: BrandsMonthYearFilterProps) {
  const yearOptions = getBrandYearOptions();

  const handleMonthChange = (event: SelectChangeEvent<number>) => {
    onSelectedMonthChange(Number(event.target.value));
  };

  const handleYearChange = (event: SelectChangeEvent<number>) => {
    onSelectedYearChange(Number(event.target.value));
  };

  return (
    <Stack direction="row" spacing={1.25}>
      <FormControl size="small" fullWidth disabled={disabled}>
        <InputLabel color="secondary">Month</InputLabel>
        <Select label="Month" value={selectedMonth} onChange={handleMonthChange} color="secondary">
          {BRAND_MONTH_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" fullWidth disabled={disabled}>
        <InputLabel color="secondary">Year</InputLabel>
        <Select label="Year" value={selectedYear} onChange={handleYearChange} color="secondary">
          {yearOptions.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
